'use client';
import { Button } from '@/components/ui/button';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React, { FC } from 'react';

interface GoBackProps {
  className?: string;
  onBackClick?: () => void;
}

export const GoBack: FC<GoBackProps> = ({ className, onBackClick }) => {
  const router = useRouter();

  const handleClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      router.back();
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant="ghost"
      size="icon"
      className={className}
    >
      <Image src="/arrow-left.svg" alt="arrow-left" width={20} height={20} />
    </Button>
  );
};
